exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multi-line-select .el-select-dropdown__item {\r\n  height: auto;\r\n  padding: 8px 10px;\r\n  line-height: 1.5;\n}\n.multi-line-option .option-line {\r\n  display: block;\r\n  line-height: 1.5;\n}\r\n", ""]);

// exports
